import {useTranslation} from '@/translations/i18n.tsx'
import {IconContainer} from '@components/ui/icon-container'
import {SearchLgIcon} from '@components/ui/icon'
import {Container} from '@components/ui/container'
import {ButtonLink} from '@components/commons/button-link'
import {routes} from '@utilities/constants/routes.tsx'

export const NotFound = () => {
    const {t} = useTranslation()

    return (
        <Container
            fullHeight
            className="grid grid-rows-[1fr] items-center justify-center p-0 bg-[url(./assets/not_found_bg.jpg)] shadow-[inset_-1px_-200px_2000px_399px_rgba(249,250,251,0.90)]"
        >
            <div className="relative grid max-w-5xl grid-cols-1 items-center justify-items-center gap-6">
                <IconContainer>
                    <SearchLgIcon />
                </IconContainer>
                <h1 className="text-display-xl font-semibold text-neutral-900 text-center">
                    {t('page_not_found:page_not_found')}
                </h1>
                <p className="text-xl text-neutral-600 mb-4 text-center">{t('not_found:subtitle')}</p>
                <ButtonLink variant="primary" size="lg" to={routes.HOME.handle.fullPath}>
                    {t('not_found:cta')}
                </ButtonLink>
            </div>
        </Container>
    )
}

NotFound.displayName = 'NotFound'
